module.exports = __webpack_public_path__ + "img/toeic5.5223e318.png";